import { Common } from '@thecvlb/design-system';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';
import StaticReviewsList from 'widgets/reviews/StaticReviewsList';

import { DUMMY_REVIEWS_WM } from '../SelectPlan/selectPlan.settings';

import iPhone from 'assets/images/signUp/iPhone.png';

const MarketingWorkingOnApproval: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col gap-2 text-center md:gap-6">
        <img
          alt="Weight loss without uncertainty."
          className="mx-auto w-[188px] md:w-[256px]"
          src={iPhone}
        />
        <h2 className="wm-signup-title" data-testid="header">
          We work with your insurance to get you approved.
        </h2>
        <p className="text-primary-700">
          We’re dedicated to providing transparency throughout your entire journey, from insurance
          coverage eligibility to the cost of your medications.
        </p>
      </div>
      <Common.Alert type="info" colorableBackground>
        As a member of the LifeMD Weight Management Program, you gain access to insurance
        assistance, which may help lower your GLP-1 medication cost to as little as $25 per month.
      </Common.Alert>
      <div className="order-3 max-md:w-full md:order-4 md:max-w-[1240px]">
        <StaticReviewsList reviews={DUMMY_REVIEWS_WM} />
      </div>
      <Common.Button
        className="order-4 md:order-3"
        color="blue"
        fullWidthOnMobile
        onClick={() => moveToStep('next')}
      >
        Continue
      </Common.Button>
    </div>
  );
};

export default MarketingWorkingOnApproval;
